import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Wij gebruiken cookies',
    description:
      'Wij gebruiken cookies en vergelijkbare technologieën om deze ervaring te bieden. Strikt noodzakelijke cookies zijn altijd actief.',
    allow_label: 'Alle cookies accepteren',
    reject_label: 'Alleen strikt noodzakelijke',
    settings_label: 'Cookie-instellingen',
    policy_link_label: 'Privacy- en cookiebeleid',
    categories_label: 'Categorieën',
    always_on_label: 'Altijd actief',
    required_label: 'Vereist',
    save_preferences_label: 'Voorkeuren opslaan',
    close_label: 'Sluiten',
    allow_all_optional_categories_label: 'Alle optionele categorieën toestaan',
    settings_title: 'Cookie-instellingen',
    settings_description:
      'Wij gebruiken cookies en vergelijkbare technologieën om deze ervaring te bieden. Strikt noodzakelijke cookies zijn altijd actief.',
    save_error: 'Uw privacykeuze kon niet worden opgeslagen. Probeer het opnieuw.'
  },
  categories: {
    strictly_necessary: {
      name: 'Strikt noodzakelijk',
      purpose: 'Nodig om deze ervaring te bieden en kunnen niet worden uitgeschakeld.'
    },
    analytics: {
      name: 'Analyse',
      purpose: 'Meet hoe bezoekers deze ervaring gebruiken om de prestaties te verbeteren.'
    },
    marketing: {
      name: 'Marketing',
      purpose: 'Ondersteunt advertenties en marketing die door de organisator zijn gekozen.'
    }
  }
};

export default locale;
